export default {
    h: $localize `Hour`,
    day: $localize `Day`,
    m: $localize `Meter`,
    km: $localize `Kilometer`,
    mi: $localize `Mile`,
    sqm: $localize `Square meter`,
    sqft: $localize `Square feet`,
    kg: $localize `Kilogram`,
    g: $localize `Gram`,
    lb: $localize `Pound`,
    l: $localize `Liter`,
    pcs: $localize `Piece`,
    service: $localize `Service`,
    unit: $localize `Unit`,
    call: $localize `Call`,
    visit: $localize `Visit`
}
